import { render, staticRenderFns } from "./OpenActive.vue?vue&type=template&id=1a74cd1d&scoped=true&"
import script from "./OpenActive.vue?vue&type=script&lang=js&"
export * from "./OpenActive.vue?vue&type=script&lang=js&"
import style0 from "./OpenActive.vue?vue&type=style&index=0&id=1a74cd1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a74cd1d",
  null
  
)

export default component.exports